import { eMode } from "../../../content/enum";
import { IDmLoaiThuTuyenSinhActionTypes } from "../../action-types/category/IDmLoaiThuTuyenSinhActions";
import { IDmLoaiThuTuyenSinhReducer } from "../../reducer-model/category/IDmLoaiThuTuyenSinhReducer";
import { IDmLoaiThuTuyenSinhRequest } from "./../../../model/request/category/dmLoaiThuTuyenSinhRequest";
import { eReducerStatusBase } from "./../../reducer-model/eReducerStatusBase";

const iniState: IDmLoaiThuTuyenSinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiThuTuyenSinhs: [],
  idSelections: [],
  loaiThuTuyenSinhTheoDots: [],
  heNganhsTheoDot: [],
  mode: eMode.xem,
  request: {
    dot_tuyen_sinh: 0,
  } as IDmLoaiThuTuyenSinhRequest,
};
export const loaiThuTuyenSinhReducer = (
  state: IDmLoaiThuTuyenSinhReducer = iniState,
  action: IDmLoaiThuTuyenSinhActionTypes
): IDmLoaiThuTuyenSinhReducer => {
  switch (action.type) {
    case "LOAI_THU_TUYEN_SINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuTuyenSinhs: action.payload,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiThuTuyenSinhEditing: action.payload,
      };
    case "LOAI_THU_TUYEN_SINH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        loaiThuTuyenSinhEditing: undefined,
      };
    case "LOAI_THU_TUYEN_SINH_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_MANY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_MANY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_TUYEN_SINH_DELETE_MANY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START":
      return {
        ...state,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS":
      return {
        ...state,
        heNganhsTheoDot: action.payload,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR":
      return {
        ...state,
        heNganhsTheoDot: [],
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_THEO_DOT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_THEO_DOT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuTuyenSinhTheoDots: action.payload,
      };
    case "LOAI_THU_TUYEN_SINH_LOAD_THEO_DOT_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_MULTIPLE_SUCCESS":
      const updatedIds = action.payload.map((x) => x.id_thu_chi_main);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuTuyenSinhTheoDots: [
          ...state.loaiThuTuyenSinhTheoDots.filter(
            (x) => !updatedIds.includes(x.id_thu_chi_main)
          ),
          ...action.payload,
        ],
      };
    case "LOAI_THU_TUYEN_SINH_SAVE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_TUYEN_SINH_CHANGE_VALUE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
